import {_} from 'underscore';
import 'deepmerge';

let value = null,
    options = {
        code: null, //currency
        html: {
            use: true,
            classes: {
                defaultCode: 'money--currency_code',
                defaultNumber: 'money--currency_number',

                code: 'money--currency_code',
                number: 'money--currency_number'
            }
        }
    };

function init(opt) {
    'use strict';
    options = $.extend(true, options, opt);
}

export function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

export function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
}

export function floatToInteger(price) {
    let number = Number(price);
    return number * 100;
}

export function integerToFloat(price) {
    let number = Number(price);
    return (number / 100).toFixed(2);
}

export function format(price, params) {
    // console.log('price',price);
    if (price.length <= 0) {
        return null;
    }
    init(params);
    price = Number(price);

    if (isInt(price)) {
        value = integerToFloat(price);
    }
    else if (isFloat(price)) {
        value = floatToInteger(price);
    }
    else {
        console.error('money value ' + price + ' could not be determined as valid currency');
        return null;
    }
    // console.log('options.code',options.code);

    if (options.code !== null) {
        let symbol = addCurrencySymbol(options.code),
            compiled = {
                code: symbol.code,
                number: value
            };

        if (options.html.use) {
            compiled = createMoneyHtml(symbol.code, value);
        }


        if (symbol.before === true) {
            return compiled.code + ( (symbol.space) ? ' ' : '' ) + compiled.number;
        } else {
            return compiled.number + ( (symbol.space) ? ' ' : '' ) + compiled.code;
        }
    } else {
        return value;
    }

}

export function isOnlyPenny(price){

}


/**
 * Returns the currency for the selected language
 * @param lang
 * @returns {*|null}
 */
function addCurrencySymbol(lang) {
    let symbols = {
        'GBP': {
            code: '£',
            space: false,
            before: true
        },
        'USD': {
            code: '$',
            space: false,
            before: true
        },
        'NZD': {
            code: '$',
            space: false,
            before: true
        },
        'AUD': {
            code: '$',
            space: false,
            before: true
        },
        'EU': {
            code: '€',
            space: false,
            before: true
        },
    };

    return symbols[lang] || null;
}

function createMoneyHtml(code, number) {
    let codeClasses = options.html.classes.defaultCode + ' ' + options.html.classes.code;
    let numberClasses = options.html.classes.defaultNumber + ' ' + options.html.classes.number;
    let html = {
        code: `<span class="${codeClasses}">${code}</span>`,
        number: `<span class="${numberClasses}">${number}</span>`
    };
    return html;
}




// WEBPACK FOOTER //
// ./resources/assets/js/helpers/money.js